import React from 'react'
import PrivateRoutes from '../config/protectedRoutes'

const RoutesContainer = () => {
  return (
    <PrivateRoutes/>
  )
}

export default RoutesContainer